export default __webpack_public_path__ + "static/media/Cookies.eb10a7bf.pdf";